import React, { CSSProperties } from 'react';

import { Grid, Step, StepLabel, Stepper } from '@mui/material';
import { MAIN_THEME } from '@styles';

import EnhancedButton, { EnhancedButtonStatus } from '../_old/EnhancedButton';

import { makeStyles } from 'tss-react/mui';

export interface IEnhancedStepperProps {
  activeStep: string;
  steps: string[];
  className?: string;
  style?: CSSProperties;
  showStepperButton?: boolean;
  buttonTitle?: string;
  buttonOnClick?: () => void;
  buttonColor?: string;
  buttonState?: EnhancedButtonStatus;
  reverseButton?: boolean;
}

const useStyles = makeStyles()(() => ({
  stepper: {
    backgroundColor: 'transparent',
    padding: 0,
    width: '100%', // Ensuring the Stepper takes full width initially
    maxWidth: '100%',
    '& .MuiStepLabel-root .Mui-active, .MuiStepLabel-root .Mui-completed': {
      color: MAIN_THEME.color.black
    },

    '@media only screen and (min-width: 600px)': {
      maxWidth: '1300px'
    }
  },
  step: {
    '& .MuiStepIcon-root': {
      height: 26,
      width: 26,
      color: MAIN_THEME.color.white86
    },
    '& .MuiStepIcon-active, .MuiStepIcon-completed': {
      color: MAIN_THEME.color.black,
      '& .MuiStepIcon-text': {
        fontSize: MAIN_THEME.fontSize.xs,
        lineHeight: '12px',
        fill: 'white'
      }
    },
    '& .MuiStepIcon-text': {
      fontSize: MAIN_THEME.fontSize.xs,
      lineHeight: '12px',
      fill: 'white'
    },
    '& .MuiStepConnector-alternativeLabel': {
      left: 'calc(-50% + 35px)',
      right: 'calc(50% + 35px)'
    }
  },
  stepLabel: {
    '& .MuiStepLabel-label': {
      fontSize: MAIN_THEME.fontSize.xs,
      lineHeight: '13px',
      fontFamily: MAIN_THEME.font.regular,
      margin: '1.5em 0 0 0',
      color: MAIN_THEME.color.white86
    },
    '& .MuiStepLabel-active, .MuiStepLabel-completed': {
      color: MAIN_THEME.color.black
    }
  }
}));

const EnhancedStepper: React.FC<IEnhancedStepperProps> = ({
  steps,
  activeStep,
  className,
  style,
  showStepperButton = false,
  buttonTitle = 'Modify',
  buttonOnClick,
  buttonColor = MAIN_THEME.color.black,
  buttonState = undefined,
  reverseButton = false
}) => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      spacing={showStepperButton ? 2 : 2}
    >
      {showStepperButton && reverseButton && (
        <Grid item xs={2} justifyContent="center">
          <EnhancedButton
            type="button"
            backgroundColor={buttonColor}
            color={MAIN_THEME.color.white}
            onClick={buttonOnClick}
            style={{ marginTop: '-15px' }}
            state={buttonState}
          >
            {buttonTitle}
          </EnhancedButton>
        </Grid>
      )}
      <Grid item xs={showStepperButton ? 10 : 10}>
        <Stepper
          activeStep={steps.indexOf(activeStep)}
          alternativeLabel
          classes={{ root: classes.stepper }}
          className={className}
          style={style}
        >
          {steps.map((label) => (
            <Step key={label} classes={{ root: classes.step }}>
              <StepLabel classes={{ root: classes.stepLabel }}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Grid>
      {showStepperButton && !reverseButton && (
        <Grid item xs={2} justifyContent="flex-end">
          <EnhancedButton
            type="button"
            backgroundColor={buttonColor}
            color={MAIN_THEME.color.white}
            onClick={buttonOnClick}
            style={{ marginTop: '-15px' }}
            state={buttonState}
          >
            {buttonTitle}
          </EnhancedButton>
        </Grid>
      )}
    </Grid>
  );
};

export default EnhancedStepper;
